import React, { useState } from 'react';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { getAppraiserActions, executeAppraiserAction } from '../AppraiserFunctions';
import { InformModal } from '../../../../common/SharedComponents';

export const AppraisersActionsButton = ({ data, inactive = false }) => {
    const { dispatch } = store;

    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const onActionClicked = (event, appraiser) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getAppraiserActions(appraiser, inactive);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var currentActions = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(currentActions);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        executeAppraiserAction(e.itemData, dispatch);
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${data.id}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </>
    );
};
